import React from "react";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import { motion as m } from "framer-motion"; // if you're using framer-motion for animation
import 'react-circular-progressbar/dist/styles.css';


const Overlay = ({ course, onClose }) => {
    const navigate = useNavigate();
    const [progress, setProgress] = useState(0); // State to store the progress
    const [totalWatched, setTotalWatched] = useState({}); // State to store the total watched count


    // console.log("Overlay Props:", { course, progress });

    useEffect(() => {
        fetch("https://dun.vydeo.xyz/iter3/get_number_watched", {
        // fetch("http://localhost:5000/get_number_watched", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            },
        })
            // fetch("https://dunderdebunk-backend-production.up.railway.app/get_number_watched", {
            //     method: "GET",
            //     headers: {
            //         Authorization: `Bearer ${localStorage.getItem("token")}`,
            //         "Content-Type": "application/json",
            //     },
            // })
            .then((response) => response.json())
            .then((data) => {
                const watchedData = data.reduce((acc, [courseId, watchedCount]) => {
                    acc[courseId] = watchedCount;
                    return acc;
                }, {});

                setTotalWatched(watchedData);

                if (course && watchedData[course.id]) {
                    const watchedCount = watchedData[course.id];
                    const progressValue = Math.min(watchedCount / 5, 100); // we have only 5 videos per course
                    setProgress(progressValue * 100);
                }

                console.log("Watched Data:", watchedData);
            })
            .catch((error) => console.error("Error fetching courses:", error));
    }, [course]); // Rerun this effect if the selected course changes


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (e.target.classList.contains("overlay-container")) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    if (!course) return null;


    return (
        <motion.div
            className="overlay-container"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.5 }}
        >
            <div className="overlay-content">
                <button className="close-btn" onClick={onClose}>✖</button>
                <img src={`/images/${course.image}`} alt={course.name} className="overlay-image" />
                <h2>{course.name}</h2>

                <div className="overlay-details">
                    <p><strong>Course Context:</strong></p>
                    <ul>
                        {course.context.map((point, index) => (
                            <li key={index}>✔️ {point}</li>
                        ))}
                    </ul>
                    <p><strong>Format:</strong> {course.format}</p>
                    <p><strong>Prerequisites:</strong> {course.prerequisites}</p>
                </div>

                {/* Circular Progress Bar */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    style={{
                        width: '100px',
                        height: '100px',
                        margin: '20px auto',  // Adds space between the progress bar and other content
                    }}
                >
                    <CircularProgressbar
                        value={progress}
                        text={`${progress}%`}
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: progress / 100 }}
                        transition={{ duration: 1 }}
                        styles={{
                            path: {

                                stroke: progress > 75 ? 'green' : progress > 50 ? 'orange' : 'red',
                                strokeWidth: 5,
                            },
                            text: {
                                fill: 'black',
                                fontSize: '16px',
                                fontWeight: 'bold',
                            },
                        }}

                    />
                </motion.div>

                <button
                    className="get-started"
                    onClick={() => navigate(`/course/${course.id}`)}
                >
                    Get Started
                </button>
            </div>
        </motion.div>
    );
};

export default Overlay;
